module.exports = __webpack_public_path__ + "static/media/1.cf2d41ab.jpg";